import { navigationVanjski } from './../../../app-navigation';
import { IMenuItem } from 'src/app/app-navigation';
import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';
import { navigationAdministrator, navigationNacelnik, navigationZaposlenik } from '../../../app-navigation';

import * as events from 'devextreme/events';
import { KorisnikType } from '../../models/korisnik.model';
import { AuthService } from '../../services';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu: DxTreeViewComponent;
  isMenuItemListSet: boolean = false;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem: String;
  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(value);
  }
  
  private _items;
  get items() {
    const moduleIds=this._authService.getUserModulIds()
    if (!this._items) {   
      if(+sessionStorage.getItem('kor_prava') == KorisnikType.ADMIN){
        this._items = navigationAdministrator.map((item) => {
          if(item.path && !(/^\//.test(item.path))){ 
            item.path = `/${item.path}`;
          }
          return { ...item, expanded: !this._compactMode }
        });
      } else if(+sessionStorage.getItem('kor_prava') == KorisnikType.NACELNIK){
        this._items = navigationNacelnik.map((item) => {
          if(item.path && !(/^\//.test(item.path))){ 
            item.path = `/${item.path}`;
          }
          return { ...item, expanded: !this._compactMode }
        });
      }
      else if(+sessionStorage.getItem('kor_prava') == KorisnikType.ZAPOSLENIK){
        this._items = navigationZaposlenik.map((item) => {
          if(item.path && !(/^\//.test(item.path))){ 
            item.path = `/${item.path}`;
          }
          return { ...item, expanded: !this._compactMode }
        });
      } else if(+sessionStorage.getItem('kor_prava') == KorisnikType.VANJSKI){
        this._items = navigationVanjski.map((item) => {
          if(item.path && !(/^\//.test(item.path))){ 
            item.path = `/${item.path}`;
          }
          return { ...item, expanded: !this._compactMode }
        });
      }
    }

    if(!this.isMenuItemListSet){
      let listaIzbornika = this._items;
      if(+sessionStorage.getItem('kor_prava') == KorisnikType.NACELNIK){
        listaIzbornika = this.filtrirajIzbornikOvisnoOAktivnimModulima(this._items, moduleIds);
      }
      listaIzbornika = this.prilagodiNaziveLinka(listaIzbornika);
      this._items = listaIzbornika;
      this.isMenuItemListSet = true;
    }
    
    return this._items;
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef, private _authService: AuthService) { }

  onItemClick(event) {
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.next(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }

  filtrirajIzbornikOvisnoOAktivnimModulima(listaOpcijaIzbornika, moduleIds){
    return listaOpcijaIzbornika.filter((item: IMenuItem) => !item.moduleId || (item.moduleId && moduleIds.includes(item.moduleId)))
  }

  prilagodiNaziveLinka(lista){
    return lista.map((item: IMenuItem,index) => {
      item.text = `${index+1} - ${item.text}`;
      return item;
    });
  }
}

@NgModule({
  imports: [ DxTreeViewModule ],
  declarations: [ SideNavigationMenuComponent ],
  exports: [ SideNavigationMenuComponent ]
})
export class SideNavigationMenuModule { }
